@import 'styles/mixins';
@import 'styles/variables';

.FontWeightDatalist {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  color: var(--neutral-40);
  z-index: z-index(actionBar);
  padding: 0 12px;
  gap: 1px;
  height: 36px;
  border-radius: 6px;

  > span {
    display: flex;
  }

  &:hover {
    background-color: var(--neutral-5);
  }

  svg {
    fill: currentColor;
    width: 12px;
    height: 12px;
  }

  .input {
    text-transform: capitalize;
    @include md-regular;
    cursor: pointer;
    background-color: transparent;
    width: 100%;
  }

  .chevron {
    font-size: 0;
    cursor: pointer;
  }
}

.list {
  @include shadow-3;
  background: var(--neutral-0);
  border-radius: 8px;
  padding: 4px;
  position: absolute;
  top: 110%;
  left: 0;
  font-size: 16px;
  width: 116px;

  .listItem {
    padding: 4px 8px;
  }

  .active,
  .listItem:focus,
  .listItem:hover {
    background: var(--neutral-5);
    border-radius: 4px;
    cursor: pointer;
  }

  .listItem:focus,
  .listItem:hover {
    outline: none;

    &.active {
      background: var(--focus-10);

      [data-autopilot-system-redesign='on'] & {
        background: var(--dark-80);
        color: var(--light-100);
      }
    }
  }

  .active {
    background: var(--focus-5);
    color: var(--focus-50);

    [data-autopilot-system-redesign='on'] & {
      background: var(--dark-80);
      color: var(--light-100);
    }
  }
}
